import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { LockClosedIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";

/**
 * CTA pill linking to the billing page for shops on the mini/retraction plan.
 */
export function PlanUpgradeCTA() {
  const { data: shop } = useCurrentShopSuspense();
  return (
    <Link
      to={`/shops/${shop?.id}/settings/billing`}
      className="flex items-center gap-1.5 rounded-full bg-indigo-600 px-4 py-1.5 text-xs font-medium text-white shadow-sm"
    >
      <LockClosedIcon className="h-3 w-3" />
      Passer au plan Lite
    </Link>
  );
}
